import { createAsyncThunk } from '@reduxjs/toolkit';
import { httpClient } from '../../../commons/adapter/http-request';

export const apiRoute = 'auth';

// #region api requests
export const postWithEmail = createAsyncThunk(
  `${apiRoute}/with_email`,
  async (payload, { signal, rejectWithValue }) => {
    try {
      const source = httpClient.CancelToken.source();
      signal.addEventListener('abort', () => {
        source.cancel();
      });
      const response = await httpClient.request({
        method: 'POST',
        url: `/carts/${payload.cartId}/with_email`,
        data: payload.data,
        cancelToken: source.token,
      });
      return response.data;
    } catch (err) {
      return rejectWithValue({
        status: err.response.status,
        data: err.response.data,
      });
    }
  },
);
// #endregion
